goog.provide('el8.appchart.refpanel.prenatalFlowsheets');

goog.require('el8.appchart.dialog.prenatalFlowsheet');
goog.require('el8.model.base');
goog.require('el8.ptdata.prenatalFlowsheets');
goog.require('el8.template.appchart.refpanel.prenatalFlowsheets');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.refpanel.RefPanelSection');
goog.require('el8.appchart.actions.prenatalFlowsheets');

el8.appchart.refpanel.prenatalFlowsheets = (function() {

    var renderFn = function() {
        $('#prenatal-flowsheets-section').removeClass('el8Loading');

        $('.prenatal-flowsheets-buttons', $('#prenatal-flowsheets-section')).html(
            el8.template.appchart.refpanel.prenatalFlowsheets.addNewTrigger()
        );

        $('#prenatal-flowsheets-summary').html(
            el8.template.appchart.refpanel.prenatalFlowsheets.list({
                flowsheets: el8.ptdata.prenatalFlowsheets.all().map(el8.model.toSoyMapFn)
            })
        );
    };

    var that = new el8.appchart.refpanel.RefPanelSection({

        initFn: function() {
            var container = $('#prenatal-flowsheets-section');
            that.addContainer(container);

            el8.uiwidget.collapsible({
                container: container,
                triggerElt: $('#prenatal-flowsheets-summary-header'),
                statusElt: $('#prenatal-flowsheets-summary-status')
            });

            container.on('click', '.add-prenatal-flowsheet-trigger',  function(e) {
                el8.appchart.dialog.prenatalFlowsheet.show();

            }).on('click', '.edit-prenatal-flowsheet-trigger',  function(e) {
                var itemId = $(this).data('id');
                var ptPrenatalFlowsheet = el8.ptdata.prenatalFlowsheets.getById(itemId);
                if (ptPrenatalFlowsheet) {
                    el8.appchart.dialog.prenatalFlowsheet.show({'ptPrenatalFlowsheet': ptPrenatalFlowsheet});
                    return false;
                }
            }).on('click', '.more-actions-trigger',  function(e) {
                var itemId = $(this).data('id');
                var ptPrenatalFlowsheet = itemId ? el8.ptdata.prenatalFlowsheets.getById(itemId) : null;
                var menu = el8.appchart.actions.prenatalFlowsheets({ item: ptPrenatalFlowsheet });
                el8.appchart.refpanel.actionsMenu.display(
                    $(this),
                    null,
                    {top: 17, left: 5},
                    menu
                );
                return false;
            });
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.prenatalFlowsheets,
                events: [{
                    eventName: 'all',
                    fn: renderFn
                }],
                renderFn: renderFn
            }
        ]
    });
    return that;

})();
